// Woerterbuch der Checkout-App. reference: [1]
import {createT, plural, teile} from '$m7-library/utils/i18n.js';
import de from './lang/de.js';
import pl from './lang/pl.js';

const t = createT({de, pl});

export {t, plural, teile};
